// extracted by mini-css-extract-plugin
module.exports = {"back":"movementDetail_back__iDWlN","title":"movementDetail_title___-ZXd","tr":"movementDetail_tr__3YGs2","action":"movementDetail_action__ykH0N"};